/**
 * Site-relative set-password document. One trailing slash is ignored.
 * `/set-password` and `/set-password/` match. A nested path does not.
 */
export function isSetPasswordPath(filepath: string | null | undefined): boolean {
    if (!filepath) {
        return false;
    }
    const withSlash = filepath.startsWith("/") ? filepath : `/${filepath}`;
    const trimmed = withSlash.endsWith("/") && withSlash.length > 1
        ? withSlash.slice(0, -1)
        : withSlash;
    return trimmed === "/set-password";
}
